define([
    "./monitoringDriverModule",
    "./monitoringDriverRouter",
    "./monitoringAlterDriverModal",
    "./MonitoringDriverEditionController",
    "./MonitoringDriverSearchController",
    "./monitoringDriverSelectionModal",
    "./monitoringDriverService"
], function () {
});